import { Dispatch, PureComponent } from 'react';
import { connect } from 'react-redux';
import { AdvicesEntity } from '../../../../store/types/prescription';
import {
    DeleteAdviceAction,
    DeleteAdvicePermanentlyAction,
    EditAdviceAction,
    editAdvices,
    UpsertAdviceAction,
} from '../../../../store/actions/prescriptionPad';
import Modal from '../../../common/Modal';
import ModalDialog from '../../../common/ModalDialog';
import TinyMCEditor from '../../../common/TinyMceEditor';
import { filterParsedText } from './Advices';

type Props = {
    dispatch: Dispatch<
        UpsertAdviceAction | EditAdviceAction | DeleteAdviceAction | DeleteAdvicePermanentlyAction
    >;

    allAdvices: AdvicesEntity[];
    editAdvice: AdvicesEntity;
    setAllAdvices: (advices: AdvicesEntity[]) => void;
    onEditAdvicesCancel: () => void;
};

type State = {
    editAdvice: AdvicesEntity | undefined;
};

class EditAdvicesModal extends PureComponent<Props, State> {
    state: State = {
        editAdvice: this.props.editAdvice,
    };

    onEditAdvices = (a: AdvicesEntity) => {
        this.setState({ editAdvice: a });
    };

    onSaveEditAdvices = (text: string, parsedText: string) => {
        const { dispatch, setAllAdvices, onEditAdvicesCancel, allAdvices } = this.props;
        const { editAdvice } = this.state;

        if (editAdvice) {
            const oldAdvice = allAdvices.find((advice) => advice.id === editAdvice.id);
            const newAdvice: AdvicesEntity & { searchText?: string } = {
                ...editAdvice,
                text: text,
                parsedText: parsedText,
            };

            delete newAdvice.searchText;
            dispatch(editAdvices(newAdvice, oldAdvice));

            const advices = allAdvices.map((advices) =>
                advices.id === editAdvice.id
                    ? { ...newAdvice, searchText: filterParsedText(parsedText || text) }
                    : advices,
            );

            setAllAdvices(advices);
        }

        onEditAdvicesCancel();
    };

    render() {
        const { editAdvice } = this.state;
        const { onEditAdvicesCancel } = this.props;

        if (!editAdvice) {
            return null;
        }

        return (
            <ModalDialog>
                <Modal closeMe={onEditAdvicesCancel} contentCssClasses={'h-50p bg-white pb-12'}>
                    <div>
                        <div className="px-16 bg-neutral-9 pt-12 pb-8 rounded-t-8 h-full w-full flex items-center justify-end">
                            <div className="w-full  select-none">
                                <div className="flex items-center font-600 text-14 leading-28">
                                    <div className="text-13 font-700">
                                        <p className="text-neutral-black text-13 font-700">
                                            Edit Advice
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="flex items-center space-x-4 cursor-pointer"
                                onClick={onEditAdvicesCancel}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 320 512"
                                    className="w-16 h-16 fill-neutral-3 hover:fill-neutral-1"
                                >
                                    <path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path>
                                </svg>
                            </div>
                        </div>
                        <div className="flex flex-col  items-center px-16 w-full">
                            <div className="flex w-full mt-16 mb-8">
                                <div className="flex flex-col w-full justify-between items-center">
                                    <div className="w-full h-full">
                                        <TinyMCEditor
                                            id={'edit-advices-editor'}
                                            onInputChange={(text, parsedText) => {
                                                this.onEditAdvices({
                                                    ...editAdvice,
                                                    text: text,
                                                    parsedText: parsedText,
                                                });
                                            }}
                                            inputValue={editAdvice.text}
                                            initialValue={
                                                this.props.editAdvice?.text ||
                                                this.props.editAdvice?.parsedText
                                            }
                                            customOptions={{
                                                inline: false,
                                                height: 160,
                                            }}
                                            parentCssClasses={
                                                'relative flex flex-col tiny-mce overflow-auto rounded-4 bg-white hide-scrollbar'
                                            }
                                            onSave={this.onSaveEditAdvices}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </ModalDialog>
        );
    }
}

export default connect()(EditAdvicesModal);
